import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { T } from 'src/assets/i18n/translation-keys';
import { Options } from '@angular-slider/ngx-slider';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-opacity-slider-control',
    templateUrl: './opacity-slider-control.component.html',
    styleUrls: ['./opacity-slider-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OpacitySliderControlComponent implements OnInit {
  @Input() opacityPercentage: number = 75;
  @Output() opacityChange = new EventEmitter<number>();

  public value = this.opacityPercentage;
  public opacitySliderOptions: Options = {
    floor: 0,
    ceil: 100,
    hidePointerLabels: true,
    hideLimitLabels: true,
  };

  public readonly T = T;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    if (this.opacityPercentage < 0 || this.opacityPercentage > 100) {
      this.value = 75;
    }
  }

  onOpacityChange(newValue: number): void {
    this.value = newValue;
    this.changeDetectorRef.markForCheck();

    this.opacityChange.emit(this.value);
  }

}
